import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    isReload: false,
    error: "", // for error message
    loading: false,
};

const reloadSlice = createSlice({
    name: "reload",
    initialState,
    reducers: {
        setReload(state, action) {
            state.isReload = action.payload;
        },
        clearError(state) {
            state.error = ""; // Clears the error message
        },
        setError(state, action) {
            state.error = action.payload;
        },
        setLoading(state, action) {
            state.loading = action.payload;
        },
    },
});

export const { setReload, clearError, setError, setLoading } = reloadSlice.actions;

export default reloadSlice.reducer;
